import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { KeyWithFilter } from '@/utils/filter/filter';

export interface ListFieldsState {
    id: string;
    key: string;
    label: string;
    type: KeyWithFilter['type'];
    value: any[] | string;
}

interface StepFormState {
    currentStep: number;
    requiredSteps: Record<
        string,
        {
            steps: number[];
            fields: string[];
        }
    >;
}

const initialState: StepFormState = {
    currentStep: 0,
    requiredSteps: {
        // as: {
        //     steps: [],
        //     fields: [],
        // },
    },
};

export const stepFormSlice = createSlice({
    name: 'dynamicFilter',
    initialState,
    reducers: {
        setCurrentStepAction: (
            state,
            action: PayloadAction<StepFormState['currentStep']>
        ) => {
            state.currentStep = action.payload;
        },
    },
});

export const { setCurrentStepAction } = stepFormSlice.actions;

export default stepFormSlice.reducer;
